module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.16.52.ae5faac8.png";